(function(){
  // GALLERY: build slides from thumb data-src (product images)
  var thumbs=[].slice.call(document.querySelectorAll('.gthumb'));
  var slides=thumbs.map(function(t){return t.getAttribute('data-src');});
  var main=document.getElementById('gmainImg');
  var dotsWrap=document.getElementById('gdots');
  var cur=0;
  var dots=[].slice.call(document.querySelectorAll('.gdot'));
  if(main){main.decoding='async';}
  // Preload + decode every slide once, off the critical path, so switching is instant (no per-swap network/decode lag).
  var gcache={};
  function gpreload(src){if(!src)return null;if(gcache[src])return gcache[src];var im=new Image();im.decoding='async';im.src=src;gcache[src]=im;return im;}
  function gpreloadAll(){slides.forEach(gpreload);}
  if('requestIdleCallback' in window){requestIdleCallback(gpreloadAll,{timeout:1500});}else{setTimeout(gpreloadAll,500);}
  function setSlide(i){
    cur=(i+slides.length)%slides.length;
    var src=slides[cur];
    thumbs.forEach(function(t,j){t.classList.toggle('active',j===cur);});
    dots.forEach(function(d,j){d.classList.toggle('active',j===cur);});
    if(!main||!src)return;
    var im=gpreload(src);
    var show=function(){if(slides[cur]!==src)return;main.src=src;main.style.animation='none';void main.offsetWidth;main.style.animation='';};
    if(im&&im.complete&&im.naturalWidth){show();}
    else if(im&&im.decode){im.decode().then(show).catch(show);}
    else{show();}
  }
  thumbs.forEach(function(t,i){t.addEventListener('click',function(){setSlide(i);});});
  dots.forEach(function(d,i){d.addEventListener('click',function(){setSlide(i);});});
  var gp=document.getElementById('gprev'),gn=document.getElementById('gnext');
  if(gp)gp.addEventListener('click',function(){setSlide(cur-1);});
  if(gn)gn.addEventListener('click',function(){setSlide(cur+1);});
  var gm=document.getElementById('gmain'),sx=0,sy=0;
  if(gm){gm.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY;},{passive:true});
  gm.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){setSlide(cur+(dx<0?1:-1));}},{passive:true});}

  // TABS
  var tabs=[].slice.call(document.querySelectorAll('.tab'));
  function showTab(name){tabs.forEach(function(t){t.classList.toggle('active',t.getAttribute('data-tab')===name);});document.querySelectorAll('.tabpanel').forEach(function(p){p.classList.toggle('active',p.getAttribute('data-panel')===name);});}
  tabs.forEach(function(t){t.addEventListener('click',function(){showTab(t.getAttribute('data-tab'));});});

  // DRAWER
  var drawer=document.getElementById('drawer'),dov=document.getElementById('drawerOv');
  var dBen=document.getElementById('drawerBenefits'),dFacts=document.getElementById('drawerFacts');
  function openDrawer(which){if(dBen)dBen.hidden=(which!=='benefits');if(dFacts)dFacts.hidden=(which!=='facts');if(drawer)drawer.classList.add('open');if(dov)dov.classList.add('open');}
  function closeDrawer(){if(drawer)drawer.classList.remove('open');if(dov)dov.classList.remove('open');}
  document.querySelectorAll('.blinks button').forEach(function(b){b.addEventListener('click',function(){openDrawer(b.getAttribute('data-drawer'));});});
  var dc=document.getElementById('drawerClose');if(dc)dc.addEventListener('click',closeDrawer);
  if(dov)dov.addEventListener('click',closeDrawer);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer();});

  // mini faq (in tabs)
  document.querySelectorAll('.mfq').forEach(function(q){q.addEventListener('click',function(){var it=q.closest('.mfaq');var a=it.querySelector('.mfa');var open=it.classList.toggle('open');a.style.maxHeight=open?a.scrollHeight+'px':0;});});

  // SEE BENEFITS reveal
  var seebenEl=document.getElementById('seeben');
  if(seebenEl){var sbb=seebenEl.querySelector('.seeben-body');var sbtn=seebenEl.querySelector('.seeben-btn');
  if(sbtn)sbtn.addEventListener('click',function(){var open=seebenEl.classList.toggle('open');sbb.style.maxHeight=open?sbb.scrollHeight+'px':0;});}

  // PURCHASE OPTIONS + add-to-cart label + hidden selling_plan
  var subExtra=document.getElementById('subExtra');
  var addBtn=document.querySelector('.addcart');
  var oneP=(addBtn&&addBtn.getAttribute('data-price-one'))||'';
  var subP=(addBtn&&addBtn.getAttribute('data-price-sub'))||'';
  var spInput=document.getElementById('sellingPlanInput');
  var planSelect=document.getElementById('planSelect');
  function currentPlanId(){
    if(planSelect&&planSelect.value)return planSelect.value;
    var sp=document.querySelector('.popt[data-plan="sub"]');
    return sp?(sp.getAttribute('data-selling-plan')||''):'';
  }
  function currentSubPrice(){
    var o=planSelect&&planSelect.options[planSelect.selectedIndex];
    return (o&&o.getAttribute('data-price'))||subP;
  }
  function selPlan(plan){
    document.querySelectorAll('.popt').forEach(function(p){p.classList.toggle('sel',p.getAttribute('data-plan')===plan);});
    if(subExtra)subExtra.style.maxHeight=(plan==='sub')?(subExtra.scrollHeight+40)+'px':'0px';
    if(addBtn){addBtn.innerHTML='Add to Cart · '+(plan==='sub'?currentSubPrice():oneP);}
    if(spInput){spInput.value=(plan==='sub')?currentPlanId():'';}
  }
  // Re-measure the open subscribe panel after fonts load / on resize so it never crops (mobile wrapping makes it taller than the initial measure).
  function sizeSub(){
    if(!subExtra)return;
    var sel=document.querySelector('.popt.sel');
    if(sel&&sel.getAttribute('data-plan')==='sub'){
      subExtra.style.maxHeight='none';
      var h=subExtra.scrollHeight;
      subExtra.style.maxHeight=h+'px';
    }
  }
  window.addEventListener('load',sizeSub);
  window.addEventListener('resize',sizeSub);
  document.querySelectorAll('.popt').forEach(function(p){p.addEventListener('click',function(){selPlan(p.getAttribute('data-plan'));});});
  if(document.querySelector('.popt')){selPlan(document.querySelector('.popt[data-plan="sub"]')?'sub':'one');setTimeout(sizeSub,250);}
  if(planSelect){planSelect.addEventListener('change',function(){var s=document.querySelector('.popt.sel');if(s&&s.getAttribute('data-plan')==='sub')selPlan('sub');});}

  // QTY -> hidden form input
  var q=1;var qv=document.getElementById('qtyv');var qi=document.getElementById('qtyInput');
  document.querySelectorAll('.qty button').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();q=Math.max(1,q+parseInt(b.getAttribute('data-q'),10));if(qv)qv.textContent=q;if(qi)qi.value=q;});});

  // BODY FAQ
  document.querySelectorAll('.faq2-q').forEach(function(qq){qq.addEventListener('click',function(){var it=qq.closest('.faq2-item');var a=it.querySelector('.faq2-a');var op=it.classList.toggle('open');a.style.maxHeight=op?a.scrollHeight+'px':0;});});

  // scroll-to-buy for sticky + final CTA
  function toBuy(){var b=document.querySelector('.buy');if(b){b.scrollIntoView({behavior:'smooth',block:'start'});}else{window.scrollTo({top:0,behavior:'smooth'});}}
  var _s=document.getElementById('sctaBtn');if(_s)_s.addEventListener('click',toBuy);
  var _f=document.getElementById('fctaBtn');if(_f)_f.addEventListener('click',toBuy);
  // STICKY CTA — Horizon scrolls inside .page-wrapper, so listen to the real scroll container (window scroll never fires there)
  var scta=document.getElementById('scta');var buyPanel=document.querySelector('.buy');
  var _scroller=document.querySelector('.page-wrapper')||window;
  function _stickyChk(){if(buyPanel&&scta){scta.classList.toggle('show',buyPanel.getBoundingClientRect().bottom<0);}}
  _scroller.addEventListener('scroll',_stickyChk,{passive:true});
  window.addEventListener('scroll',_stickyChk,{passive:true});
  _stickyChk();

  // EDUCATION toggle
  document.querySelectorAll('.edu-tab').forEach(function(t){t.addEventListener('click',function(){var e=t.getAttribute('data-e');document.querySelectorAll('.edu-tab').forEach(function(x){x.classList.toggle('on',x.getAttribute('data-e')===e);});document.querySelectorAll('.eslide').forEach(function(s){s.classList.toggle('on',s.getAttribute('data-e')===e);});});});

  // ANIMATED STAT COUNT-UP
  var counted=false;
  function runCounts(){
    if(counted)return;var astat=document.querySelector('.astat');if(!astat)return;
    var r=astat.getBoundingClientRect();if(r.top>=window.innerHeight||r.bottom<=0)return;counted=true;
    document.querySelectorAll('.astat .n').forEach(function(el){
      var target=parseFloat(el.getAttribute('data-count'));var dec=parseInt(el.getAttribute('data-dec')||'0',10);var suf=el.getAttribute('data-suffix')||'';var t0=null;
      function step(ts){if(!t0)t0=ts;var p=Math.min(1,(ts-t0)/1400);var eased=1-Math.pow(1-p,3);el.textContent=(target*eased).toFixed(dec)+suf;if(p<1)requestAnimationFrame(step);else el.textContent=target.toFixed(dec)+suf;}
      requestAnimationFrame(step);
    });
  }
  (document.querySelector('.page-wrapper')||window).addEventListener('scroll',runCounts,{passive:true});
  window.addEventListener('scroll',runCounts,{passive:true});runCounts();
})();

// Registered in a SEPARATE IIFE, deliberately. It used to live at the end of the main
// block, so any earlier error killed the handler and the form fell back to a native
// POST to /cart/add. Isolating it means add-to-cart survives failures elsewhere.
(function(){
  try{
  // ---- ADD TO CART (AJAX) ----
  // The native {% form 'product' %} does a full POST to /cart/add followed by a redirect to /cart.
  // The theme editor cannot follow that redirect, which is what throws "Failed to load the page".
  // Posting to /cart/add.js keeps us on the page, preserves selling_plan (subscriptions),
  // and lets us surface real Shopify errors (sold out, etc.) inline instead of on a blank page.
  var _root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  document.querySelectorAll('form.kindly-pf').forEach(function(pf){
    pf.addEventListener('submit',function(ev){
      ev.preventDefault();
      var btn=pf.querySelector('.addcart');
      if(!btn||btn.getAttribute('data-busy')==='1')return;
      var restore=btn.innerHTML;
      btn.setAttribute('data-busy','1');btn.disabled=true;btn.textContent='Adding…';

      function reset(){btn.removeAttribute('data-busy');btn.disabled=false;btn.innerHTML=restore;}
      function clearErr(){var e=pf.querySelector('.atc-err');if(e)e.parentNode.removeChild(e);}
      function fail(msg){
        reset();clearErr();
        var e=document.createElement('p');
        e.className='atc-err';
        e.setAttribute('role','alert');
        e.style.cssText='margin:10px 0 0;font-size:14px;line-height:1.4;color:#b3261e;text-align:center';
        e.textContent=msg;
        btn.insertAdjacentElement('afterend',e);
      }

      var fd=new FormData(pf);
      if(!fd.get('selling_plan'))fd.delete('selling_plan'); // empty value is rejected by the Ajax API

      fetch(_root+'cart/add.js',{
        method:'POST',
        body:fd,
        credentials:'same-origin',
        headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}
      })
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,body:j};},function(){return {ok:false,body:null};});})
      .then(function(res){
        if(!res.ok){
          fail((res.body&&(res.body.description||res.body.message))||'Sorry, that could not be added to your cart.');
          return;
        }
        clearErr();
        btn.textContent='Added ✓';
        // Straight to checkout, not /cart. Never navigate inside the customizer.
        if(window.Shopify&&Shopify.designMode){setTimeout(reset,1800);return;}
        window.location.href=_root+'checkout';
      })
      .catch(function(){fail('Network error. Please try again.');});
    });
  });
  }catch(e){ if(window.console&&console.warn)console.warn('[kindly] add-to-cart init failed:',e); }
})();
